export default {"src":"/_next/static/media/404-light.ab173426.svg","height":253,"width":502,"blurWidth":0,"blurHeight":0};